import {useEffect, useRef, useState, type ButtonHTMLAttributes, type FC, type ReactElement } from 'react';

import { Tooltip } from '@pp/core/src/components/tooltip/Tooltip';
import { useIsLargerThanWide } from '@pp/core/src/styles/hooks/media';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { Bets } from '../../config/bets';
import { useBetsInputToolTip } from '../gameGrid/hooks';

import styles from './QuickBet.module.css';

export interface QuickBetProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  weight: number;
  value: string;
  isDisabled: boolean;
  onQuickBet: (value: number) => void;
  totalTip: string;
  pointerLeave: () => void;
  betCode: Bets;
}
export const QuickBet: FC<QuickBetProps> = ({
  weight,
  value,
  onQuickBet,
  isDisabled,
  totalTip,
  pointerLeave,
  betCode,
}): ReactElement => {
  const qbRef = useRef<HTMLDivElement>(null);
  const mods = useModifiers(styles, 'quick_bet', {
    disabled: isDisabled,
  });
  const { balanceInSufficientReached } = useBetsInputToolTip(betCode);
  const [forceTollTip, setForceTollTip] = useState(false);
  const isWide = useIsLargerThanWide();

  const onClickQuickBet = (): void => {
    onQuickBet(weight);
    if (balanceInSufficientReached) {
      setForceTollTip(true);
    }
  };

  const onPointerLeave = (): void => {
    pointerLeave();
  };

  useEffect(() => {
    const childEl = qbRef?.current;

    if (childEl) {
      childEl.addEventListener('pointerleave', onPointerLeave);
      childEl.addEventListener('onblur', onPointerLeave);
    }

    return () => {
      if (!childEl) return;
      childEl?.removeEventListener('pointerleave', onPointerLeave);
      childEl?.removeEventListener('onblur', onPointerLeave);
    };
  }, [qbRef]);

  return (
    <button className={`${styles.quick_bet} ${mods}`} onClick={onClickQuickBet}>
      <Tooltip
        text={totalTip}
        targetRef={qbRef}
        displayOnTouch={!isWide && forceTollTip}
        displayTrigger={!isWide && forceTollTip}
      />
      <div ref={qbRef} className={styles.quick_bet_text}>
        {'+'}
        {value}
      </div>
    </button>
  );
};
